import { render, staticRenderFns } from "./aiAlarmDetail.vue?vue&type=template&id=97c6cab2&scoped=true"
import script from "./aiAlarmDetail.vue?vue&type=script&lang=js"
export * from "./aiAlarmDetail.vue?vue&type=script&lang=js"
import style0 from "./aiAlarmDetail.vue?vue&type=style&index=0&id=97c6cab2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c6cab2",
  null
  
)

export default component.exports